import moment from 'moment';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { DASHBOARD_TYPE } from '@utils/constants';
import { getFilterFromRules } from '@utils';
import { showRollingWindow } from '@utils/dashboard/rollingWindow';
import { ALL_TRAFFIC } from '@utils/filter';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';

const storage = createJSONStorage(() => sessionStorage);
export const getChoiceAtom = (id) => atomWithStorage(`compare-migration-choice-${id}`, '', storage);

export const createTempDashboardConfig = (config) => {
  const { filterBars, savedFilters, interval: oldInterval, metricList } = config;

  const metric = metricList[0];
  const compareFilters = filterBars.map((fb) => getFilterFromRules(fb.filters));

  savedFilters.forEach((fb) => {
    const filter = getFilterFromRules(fb.filters);
    filter.name = fb.name || filter.name; // override name for saved filters
    compareFilters.push(filter);
  });

  const interval = { ...oldInterval };
  delete interval.scrollingWindow;

  return {
    // usecase key enforces the new drill-down workflow (without injector layer)
    usecaseKey: 'compare-dashboard',
    metricsChartContainer: {
      metric: getInvertedPercentageMetricByKey({
        metricKey: metric,
        defaultValue: metric,
      }),
      metrics: metricList,
    },
    common: {
      appliedFilters: [ALL_TRAFFIC],
      interval,
    },
    'module:trends': {
      base: {
        compareFilters,
      },
    },
    toggles: {
      sections: {
        summary: false,
      },
    },
    metricPanel: {
      size: 'm',
    },
  };
};

export const createSavedDashboardConfig = ({ config, name = 'compare-dashboard' }) => {
  const { filterBars, savedFilters, interval: oldInterval, metricList } = config;

  const metric = metricList[0];

  const compareFilters = filterBars.map((fb) => getFilterFromRules(fb.filters));
  savedFilters.forEach((fb) => {
    const filter = getFilterFromRules(fb.filters);
    filter.name = fb.name || filter.name; // override name for saved filters
    compareFilters.push(filter);
  });

  const interval = { ...oldInterval };
  delete interval.scrollingWindow;

  return {
    config: {
      title: `compare ${interval.from} - ${interval.to}`,
      dashboard: 'trends',
      start: interval.from,
      end: interval.to,
      meta: {
        // true if it's not a custom date as compare had rolling feature support
        rollingWindow: showRollingWindow(interval),
      },
      state: {
        metricsChartContainer: {
          metric: getInvertedPercentageMetricByKey({
            metricKey: metric,
            defaultValue: metric,
          }),
          metrics: metricList,
        },
        common: {
          appliedFilters: [ALL_TRAFFIC],
          interval,
        },
        'module:trends': {
          base: {
            compareFilters,
          },
        },
        toggles: {
          sections: {
            summary: false,
          },
        },
        metricPanel: {
          size: 'm',
        },
      },
    },
    name: `${name} (${moment().format()})`,
    isPublic: false,
    isSaved: true,
    dashboardTypeId: DASHBOARD_TYPE.TRENDS,
  };
};
